import BreadcrumbItem from 'Components/Atoms/BreadcrumbItem/BreadcrumbItem';
import { Container } from 'Components/Atoms/ContainerDeprecated/Container';
import Breadcrumbs from 'Components/Molecules/Breadcrumbs/Breadcrumbs';
import PageHeader from 'Components/Organisms/PageHeader/PageHeader';
import PageTemplate from 'Components/Templates/Page/Page/PageTemplate';
import { Helmet } from 'react-helmet-async';
import {ROUTE, ROUTES} from 'Services/Route/Route.types';
import EntityHelper from 'Services/Settings/Entity/EntityHelper';
import EntityOverviewPage from 'Components/Organisms/Entity/EntityOverviewPage/EntityOverviewPage';

const OfferOverviewPage = () => {
    return <PageTemplate>
        <Helmet>
            <title>{ROUTES.OFFERS.title}</title>
        </Helmet>

        <EntityOverviewPage
            entity_name='offer'
        />
    </PageTemplate>;
}

export default OfferOverviewPage;